import { useTranslation, Button } from '@packages/utils';
import { TSaveActionProps } from './SaveAction.types';

const SaveAction = ({
  isLoading,
  formHasChange,
  handleSubmit,
}: TSaveActionProps) => {
  const { t } = useTranslation({
    keyPrefix: 'descriptions.admin-portal.lightBox.actions',
  });

  return (
    <Button
      loading={isLoading}
      type="primary"
      color="primary"
      onClick={handleSubmit}
      disabled={!formHasChange}
    >
      {t('save.LABEL')}
    </Button>
  );
};

export default SaveAction;
